/*
  Size chart tab + modal behaviour.

  Deliberately tiny. The markup uses a native <dialog>, so the focus trap, Escape-to-close,
  inerting of the page behind the modal and returning focus to the tab on close all come from the
  browser. Only three things are left to wire: opening it, the close button, and the click on the
  backdrop.

  Guarded against double-binding because snippets/tv-size-chart.liquid emits the <script> tag
  alongside the markup — the block is limited to one per section today, but a second render must
  not bind every handler twice.
*/
(() => {
  if (window.tvSizeChartLoaded) return;
  window.tvSizeChartLoaded = true;

  const init = () => {
    document.querySelectorAll('[data-tv-size-chart]').forEach((root) => {
      if (root.dataset.tvSizeChartBound === 'true') return;

      const tab = root.querySelector('[data-tv-size-chart-open]');
      const dialog = root.querySelector('dialog');
      if (!tab || !dialog) return;

      root.dataset.tvSizeChartBound = 'true';

      // The block renders inside .product__info-wrapper, which Dawn's scroll-reveal animation
      // leaves carrying transform: matrix(1, 0, 0, 1, 0, 0). An identity transform still makes a
      // containing block for position: fixed, so the tab pins to that column instead of the
      // viewport — measured 1440px off on a 1440px window. Reparenting to <body> is what makes
      // the tab immune to whatever the surrounding markup does. The dialog does not need this:
      // showModal() promotes it to the top layer, which is outside the ancestor chain entirely.
      if (root.parentElement !== document.body) document.body.appendChild(root);

      // Revealed only once it is correctly positioned. Nothing is lost when this script fails to
      // load: a <dialog> cannot be opened without JS, so a visible tab would be a dead control.
      root.setAttribute('data-tv-size-chart-ready', '');

      tab.addEventListener('click', () => {
        // showModal rather than show: only the modal form gets the backdrop and the focus trap.
        if (typeof dialog.showModal === 'function') dialog.showModal();
      });

      const closeButton = root.querySelector('[data-tv-size-chart-close]');
      if (closeButton) closeButton.addEventListener('click', () => dialog.close());

      dialog.addEventListener('click', (event) => {
        // The dialog fills the viewport and the panel sits inside it, so a click that reaches the
        // dialog itself missed the panel. Testing currentTarget instead would always be true.
        if (event.target === dialog) dialog.close();
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
